import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function Bag(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, "data-tidal": "TidalIllustration", "data-tidal-illustration": "Bag", sx, viewBox, children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M39.5611 42.0001H7.919c-1.13684 0-2.08421-1.0421-1.89474-2.179l3.22106-22.7368c.09474-.9474.94738-1.6105 1.89478-1.6105h25.1052c.9474 0 1.7053.6631 1.8948 1.6105l3.221 22.7368c.1895 1.1369-.6631 2.179-1.8 2.179Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M17.1087 23.9996c1.5697 0 2.8421-1.2724 2.8421-2.8421 0-1.5696-1.2724-2.8421-2.8421-2.8421-1.5696 0-2.8421 1.2725-2.8421 2.8421 0 1.5697 1.2725 2.8421 2.8421 2.8421Zm13.2627 0c1.5697 0 2.8421-1.2724 2.8421-2.8421 0-1.5696-1.2724-2.8421-2.8421-2.8421-1.5696 0-2.8421 1.2725-2.8421 2.8421 0 1.5697 1.2725 2.8421 2.8421 2.8421Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M30.3707 19.2632c-.5684 0-.9474-.379-.9474-.9474V13.579c0-3.1264-2.5579-5.68426-5.6842-5.68426-3.1263 0-5.6842 2.55786-5.6842 5.68426v4.7368c0 .5684-.379.9474-.9474.9474s-.9473-.379-.9473-.9474V13.579c0-4.16847 3.4105-7.579 7.5789-7.579s7.579 3.41053 7.579 7.579v4.7368c0 .5684-.379.9474-.9474.9474Z",
        fill: theme.vars.palette.primary.dark
      }
    )
  ] });
}
Bag.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "Bag"
};
validateTidalLicense();
export {
  Bag
};
//# sourceMappingURL=Bag.js.map
